import { useVehicleStore } from "../game/state/vehicleSlice";

/**
 * Controles educativos del vehículo en la pista de automóvil:
 * avanzar / detener / retroceder / reiniciar sobre una trayectoria
 * controlada (no es un simulador libre).
 */
export function VehicleControls() {
  const play = useVehicleStore((s) => s.play);
  const progress = useVehicleStore((s) => s.progress);
  const { forward, reverse, stop, reset } = useVehicleStore();

  return (
    <section aria-label="Control del vehículo en pista" className="flex flex-col gap-2 rounded-md border border-[var(--cale-border)] p-3">
      <h3 className="text-sm font-semibold">Trayecto del vehículo (demostración)</h3>
      <div
        className="h-2 overflow-hidden rounded-full bg-[var(--cale-surface)]"
        role="progressbar"
        aria-valuenow={Math.round(progress * 100)}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Progreso del recorrido del vehículo"
      >
        <div className="h-full bg-[var(--cale-accent)] transition-all" style={{ width: `${progress * 100}%` }} />
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={reverse}
          disabled={play === "reverse" || progress === 0}
          className="rounded-md border border-[var(--cale-border)] px-3 py-1.5 text-sm disabled:opacity-40"
        >
          Retroceder
        </button>
        <button
          type="button"
          onClick={stop}
          disabled={play === "stopped"}
          className="rounded-md border border-[var(--cale-border)] px-3 py-1.5 text-sm disabled:opacity-40"
        >
          Detener
        </button>
        <button
          type="button"
          onClick={forward}
          disabled={play === "forward" || progress === 1}
          className="rounded-md bg-[var(--cale-accent)] px-3 py-1.5 text-sm text-white disabled:opacity-40"
        >
          Avanzar
        </button>
        <button
          type="button"
          onClick={reset}
          className="rounded-md border border-[var(--cale-border)] px-3 py-1.5 text-sm"
        >
          Reiniciar
        </button>
      </div>
    </section>
  );
}
